/**
 * 格式化为北京时间 24 小时制：YYYY/MM/DD HH:mm:ss
 * 后端常把北京墙钟误标成 UTC(Z)，此时用 UTC 分量即正确北京时间。
 */
export function formatBeijingDateTime(value) {
  if (!value) return '—';
  const raw = String(value).trim();
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return raw;
  const pad = (n) => String(n).padStart(2, '0');
  const mislabeledAsUtc = /T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+]00:00)$/i.test(raw);
  const opts = {
    timeZone: mislabeledAsUtc ? 'UTC' : 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  const parts = new Intl.DateTimeFormat('en-CA', opts).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value || '00';
  return `${get('year')}/${get('month')}/${get('day')} ${pad(Number(get('hour')))}:${get('minute')}:${get('second')}`;
}
